import { Provider } from '@angular/core';

import {
  WALKTHROUGH_ANCHOR_REGISTRY,
  WALKTHROUGH_NAVIGATOR,
  WALKTHROUGH_RENDERER,
} from '@ups/xplat/base/in-app-help';

import { WalkthroughDriverService } from './walkthrough-driver.service';
import { WebAnchorRegistryService } from './web-anchor-registry.service';
import { WebWalkthroughNavigatorService } from './web-walkthrough-navigator.service';

/** Binds the player's three platform seams to their web implementations. */
export const WALKTHROUGH_WEB_PROVIDERS: Provider[] = [
  { provide: WALKTHROUGH_RENDERER, useExisting: WalkthroughDriverService },
  {
    provide: WALKTHROUGH_ANCHOR_REGISTRY,
    useExisting: WebAnchorRegistryService,
  },
  {
    provide: WALKTHROUGH_NAVIGATOR,
    useExisting: WebWalkthroughNavigatorService,
  },
];
